import {Directive, DestroyRef, ElementRef, inject, input, OnInit} from '@angular/core';
import {outputToObservable, takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DropdownComponent} from '../dropdown.component';

@Directive({
    selector: '[appDropdownTriggerFor]',
    host: {
      '[style.cursor]': '"pointer"',
      '[style.position]': '"relative"'
    }
})
export class DropdownTriggerForDirective implements OnInit {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly destroyRef = inject(DestroyRef);

  public readonly appDropdownTriggerFor = input.required<DropdownComponent>();

  public ngOnInit(): void {
    outputToObservable(this.appDropdownTriggerFor().clickEvent)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(event => {
        const clickedInside = this.element.contains(event.target as Node);

        if (clickedInside) {
          this.toggleDropdown();
        } else {
          this.hideDropdown();
        }
      });
  }

  private get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  private toggleDropdown(): void {
    this.element.classList.toggle('open');

    const dropdownYPosition = this.element.getBoundingClientRect().y;
    this.appDropdownTriggerFor().aboveTrigger.set(dropdownYPosition > globalThis.innerHeight / 2);

    const dropdownXPosition = this.element.getBoundingClientRect().x;
    this.appDropdownTriggerFor().leftOfTrigger.set(dropdownXPosition < globalThis.innerWidth / 2);

    this.appDropdownTriggerFor().toggleDropdown();
  }

  private hideDropdown(): void {
    this.element.classList.remove('open');
    this.appDropdownTriggerFor().hideDropdown();
  }
}
